import React from 'react';

function Download() {
  return (
    <div id="application">
      <h2 className='text-white'>.</h2>
      <section className="section-padding download-section">
        <div className="container-lg">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h2 className="download-title">Ready to get started with FastInQueue?</h2>
              <p className="download-subtitle">
                Download the app today and connect with healthcare professionals instantly. Manage your health journey seamlessly.
              </p>

              <div className="d-flex justify-content-center flex-wrap">
                <a href="#" className="store-btn google-play-btn" style={{ backgroundColor: 'white', color: '#000' }}>
                  <i className="bi bi-google-play" style={{ color: '#000' }}></i>
                  <div className="store-btn-text text-start">
                    <span className="store-btn-sub text-dark">GET IT ON</span>
                    <span className="store-btn-main">Google Play</span>
                  </div>
                </a>
                <a href="#" className="store-btn app-store-btn" style={{ backgroundColor: 'white', color: '#000' }}>
                  <i className="bi bi-apple" style={{ color: '#000' }}></i>
                  <div className="store-btn-text text-start">
                    <span className="store-btn-sub text-dark">Download on the</span>
                    <span className="store-btn-main">App Store</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Download;
